import { render, staticRenderFns } from "./FormPropuesta.vue?vue&type=template&id=e24c86c8&"
import script from "./FormPropuesta.vue?vue&type=script&lang=js&"
export * from "./FormPropuesta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports